// The API ended this session at a renewal (session_ended: someone else may have had it), so the sign-in page can say
// why the user was signed out. In sessionStorage: this tab only, gone once the tab is.
const KEY = 'tsa-session-ended';

export function markSessionEnded(): void {
    try {
        sessionStorage.setItem(KEY, '1');
    } catch {
        // Storage refused (private browsing): the user just isn't told why.
    }
}

// Whether it was, forgetting it: said once.
export function takeSessionEnded(): boolean {
    try {
        const ended = sessionStorage.getItem(KEY) === '1';
        sessionStorage.removeItem(KEY);
        return ended;
    } catch {
        return false;
    }
}
